// import React, { useState, useEffect } from 'react';
// import {
//     Box,
//     Button,
//     TextField,
//     Typography,
//     Grid,
//     Paper,
//     Divider,
//     CircularProgress
// } from '@mui/material';
// import { useLocation, useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import apiUrl from '../../Config';
// import HtmlEditor from '../../Common/HtmlEditor';

// const AddEditBlogs = () => {
//     const { state } = useLocation();
//     const navigate = useNavigate();
//     const editingBlog = state?.blog;
//     const [loading, setLoading] = useState(false)

//     const [form, setForm] = useState({
//         name: '',
//         title: '',
//         content: ''
//     });

//     const [blogImg, setBlogImg] = useState(null);
//     const [previewImg, setPreviewImg] = useState('');

//     useEffect(() => {
//         if (editingBlog) {
//             setForm({
//                 name: editingBlog.name || '',
//                 title: editingBlog.title || '',
//                 content: editingBlog.content || ''
//             });
//             setPreviewImg(editingBlog.imageUrl || '');
//         }
//     }, [editingBlog]);

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setForm(prev => ({ ...prev, [name]: value }));
//     };

//     const handleFileChange = (e) => {
//         const file = e.target.files[0];
//         setBlogImg(file);
//         setPreviewImg(URL.createObjectURL(file));
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setLoading(true)
//         const formData = new FormData();
//         formData.append('name', form.name);
//         formData.append('title', form.title);
//         formData.append('content', form.content);
//         if (blogImg) formData.append('blogImg', blogImg);

//         try {
//             if (editingBlog?.id) {
//                 await axios.put(`${apiUrl}/blogs/updateblog/${editingBlog.id}`, formData);
//             } else {
//                 await axios.post(`${apiUrl}/blogs/createblog`, formData);
//             }
//             navigate('/display-blogs');
//         } catch (error) {
//             console.error('Blog submit error:', error);
//         } finally {
//             setLoading(false)
//         }
//     };

//     return (
//         <Box display="flex" justifyContent="center" mt={0.5} >
//             <Paper elevation={3} sx={{ width: '100%', padding: { sm: 2, xs: 2, md: 4, lg: 4 }, boxShadow: 'none' }}>
//                 <Typography variant="h5" gutterBottom align="left" mb={2}>
//                     {editingBlog ? 'Edit Blog' : 'Create Blog'}
//                 </Typography>

//                 <Box p={2} border={'1px solid lightgray'}>
//                     <form onSubmit={handleSubmit} encType="multipart/form-data">
//                         <Grid container spacing={3}>
//                             <Grid size={{ xs: 12, sm: 6 }}>
//                                 <TextField
//                                     fullWidth
//                                     label="Author Name"
//                                     name="name"
//                                     value={form.name}
//                                     onChange={handleChange}
//                                     required
//                                 />
//                             </Grid>

//                             <Grid size={{ xs: 12, sm: 6 }}>
//                                 <TextField
//                                     fullWidth
//                                     label="Title"
//                                     name="title"
//                                     value={form.title}
//                                     onChange={handleChange}
//                                     required
//                                 />
//                             </Grid>

//                             <Grid size={{ xs: 12 }}>
//                                 <Typography variant="subtitle1" gutterBottom>
//                                     Content
//                                 </Typography>
//                                 <HtmlEditor
//                                     value={form.content}
//                                     onChange={(value) => setForm(prev => ({ ...prev, content: value }))}
//                                     placeholder="Enter blog content here..."
//                                 />
//                             </Grid>

//                             <Grid size={{ xs: 12 }}>
//                                 <Button variant="outlined" component="label" >
//                                     Upload Blog Image
//                                     <input
//                                         type="file"
//                                         hidden
//                                         accept="image/*"
//                                         onChange={handleFileChange}
//                                     />
//                                 </Button>
//                                 {previewImg && (
//                                     <Box mt={2} textAlign="center">
//                                         <img
//                                             src={previewImg}
//                                             alt="Preview"
//                                             style={{
//                                                 width: '100%',
//                                                 maxHeight: 250,
//                                                 objectFit: 'contain',
//                                                 borderRadius: 8,
//                                                 border: '1px solid #ccc'
//                                             }}
//                                         />
//                                     </Box>
//                                 )}
//                             </Grid>

//                             <Grid size={{ xs: 12 }} sx={{ display: 'flex', justifyContent: 'end', gap: 3 }}>
//                                 <Button onClick={() => navigate('/display-blogs')} variant='outlined'>Cancel</Button>

//                                 <Button
//                                     type="submit" variant="contained" color="primary" size="normal"
//                                     disabled={loading}
//                                     startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
//                                 >
//                                     {loading ? editingBlog ? 'Updating...' : 'Creating...'
//                                         : editingBlog ? 'Update Blog' : 'Create Blog'}
//                                 </Button>
//                             </Grid>
//                         </Grid>
//                     </form>
//                 </Box>
//             </Paper>
//         </Box>
//     );
// };

// export default AddEditBlogs;


import React, { useState, useEffect } from 'react';
import {
    Box,
    Button,
    TextField,
    Typography,
    Grid,
    Paper,
    CircularProgress,
} from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import apiUrl from '../../Config';
import HtmlEditor from '../../Common/HtmlEditor';
import { toast } from 'react-toastify';

const AddEditBlogs = () => {
    const { state } = useLocation();
    const navigate = useNavigate();
    const editingBlog = state?.blog;
    const [loading, setLoading] = useState(false);

    const [form, setForm] = useState({
        name: '',
        title: '',
        content: '',
    });

    const [blogImg, setBlogImg] = useState(null);
    const [previewImg, setPreviewImg] = useState('');

    const [errors, setErrors] = useState({
        name: '',
        title: '',
        content: '',
        blogImg: '',
        submit: '',
    });

    useEffect(() => {
        if (editingBlog) {
            setForm({
                name: editingBlog.name || '',
                title: editingBlog.title || '',
                content: editingBlog.content || '',
            });
            setPreviewImg(editingBlog.imageUrl || '');
        }
    }, [editingBlog]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
        setErrors((prev) => ({ ...prev, [name]: '' }));
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        setBlogImg(file);
        setPreviewImg(URL.createObjectURL(file));
        setErrors((prev) => ({ ...prev, blogImg: '' }));
    };

    const validate = () => {
        let valid = true;
        const newErrors = { name: '', title: '', content: '', blogImg: '', submit: '' };

        if (!form.name.trim()) {
            newErrors.name = 'Author name is required';
            valid = false;
        }
        if (!form.title.trim()) {
            newErrors.title = 'Title is required';
            valid = false;
        }
        if (!form.content.trim()) {
            newErrors.content = 'Content is required';
            valid = false;
        }
        if (!editingBlog && !blogImg) {
            newErrors.blogImg = 'Blog image is required';
            valid = false;
        }

        setErrors(newErrors);
        return valid;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;

        setLoading(true);
        setErrors((prev) => ({ ...prev, submit: '' }));

        const formData = new FormData();
        formData.append('name', form.name);
        formData.append('title', form.title);
        formData.append('content', form.content);
        if (blogImg) formData.append('blogImg', blogImg);

        try {
            if (editingBlog?.id) {
                await axios.put(`${apiUrl}/blogs/updateblog/${editingBlog.id}`, formData, {
                    headers: { 'Content-Type': 'multipart/form-data' },
                });
                toast.success('Blog updated successfully!');
            } else {
                await axios.post(`${apiUrl}/blogs/createblog`, formData, {
                    headers: { 'Content-Type': 'multipart/form-data' },
                });
                toast.success('Blog created successfully!');
            }
            navigate('/display-blogs');
        } catch (error) {
            console.error('Blog submit error:', error);
            const message = error?.response?.data?.message || 'Failed to submit blog';
            setErrors((prev) => ({ ...prev, submit: message }));
            toast.error(message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box display="flex" justifyContent="center" mt={0.5} >
            <Paper elevation={3} sx={{ width: '100%', padding: { sm: 2, xs: 2, md: 4, lg: 4 }, boxShadow: 'none' }}>
                <Typography variant="h5" gutterBottom align="left" mb={2}>
                    {editingBlog ? 'Edit Blog' : 'Create Blog'}
                </Typography>

                <Box p={2} border={'1px solid lightgray'}>
                    <form onSubmit={handleSubmit} encType="multipart/form-data">
                        <Grid container spacing={3}>
                            <Grid size={{ xs: 12, sm: 6 }}>
                                <TextField
                                    fullWidth
                                    label="Author Name"
                                    name="name"
                                    value={form.name}
                                    onChange={handleChange}
                                    error={!!errors.name}
                                    helperText={errors.name}
                                    disabled={loading}
                                />
                            </Grid>

                            <Grid size={{ xs: 12, sm: 6 }}>
                                <TextField
                                    fullWidth
                                    label="Title"
                                    name="title"
                                    value={form.title}
                                    onChange={handleChange}
                                    error={!!errors.title}
                                    helperText={errors.title}
                                    disabled={loading}
                                />
                            </Grid>

                            <Grid size={{ xs: 12 }}>
                                <Typography variant="subtitle1" gutterBottom>
                                    Content
                                </Typography>
                                <HtmlEditor
                                    value={form.content}
                                    onChange={(value) => {
                                        setForm((prev) => ({ ...prev, content: value }));
                                        setErrors((prev) => ({ ...prev, content: '' }));
                                    }}
                                    placeholder="Enter blog content here..."
                                    readOnly={loading}
                                />
                                {errors.content && (
                                    <Typography variant="caption" color="error" mt={0.5} display="block">
                                        {errors.content}
                                    </Typography>
                                )}
                            </Grid>

                            <Grid size={{ xs: 12 }}>
                                <Button variant="outlined" component="label" disabled={loading}>
                                    Upload Blog Image
                                    <input
                                        type="file"
                                        hidden
                                        accept="image/*"
                                        onChange={handleFileChange}
                                    />
                                </Button>
                                {errors.blogImg && (
                                    <Typography variant="caption" color="error" display="block" mt={0.5}>
                                        {errors.blogImg}
                                    </Typography>
                                )}
                                {previewImg && (
                                    <Box mt={2} textAlign="center">
                                        <img
                                            src={previewImg}
                                            alt="Preview"
                                            style={{
                                                width: '100%',
                                                maxHeight: 250,
                                                objectFit: 'contain',
                                                borderRadius: 8,
                                                border: '1px solid #ccc',
                                            }}
                                        />
                                    </Box>
                                )}
                            </Grid>

                            {errors.submit && (
                                <Grid size={{ xs: 12 }}>
                                    <Typography color="error" mt={2} mb={1}>
                                        {errors.submit}
                                    </Typography>
                                </Grid>
                            )}

                            <Grid size={{ xs: 12 }} sx={{ display: 'flex', justifyContent: 'end', gap: 3 }}>
                                <Button onClick={() => navigate('/display-blogs')} variant='outlined' disabled={loading}>
                                    Cancel
                                </Button>

                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    size="normal"
                                    disabled={loading}
                                    startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
                                >
                                    {loading ? (editingBlog ? 'Updating...' : 'Creating...') : (editingBlog ? 'Update Blog' : 'Create Blog')}
                                </Button>
                            </Grid>
                        </Grid>
                    </form>
                </Box>
            </Paper>
        </Box>
    );
};

export default AddEditBlogs;
